import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

export const InputsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 2px;
`;

export const Input = styled.input`
  border: 1px solid ${colors.purple6};
  border-radius: 4px;
  padding: 5px 8px;

  font-size: 11px;
  line-height: 16px;
  font-weight: 400;
  background-color: inherit;
  color: ${colors.whiteText};

  &::placeholder {
    color: ${colors.purple6};
  }
`;
